import { newToolFilterOAuthMcp } from "../oauth.ts";

export const supabaseMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://supabase.com/favicon/apple-icon-180x180.png",
  url: "https://mcp.supabase.com/mcp",
  label: "Supabase",
});
